import createStateReducer from "../../helpers/createStateReducer";
import reloadingEnrolmentsAndCohortsStates from "../../states/reloadingEnrolmentsAndCohorts";
import deltas from "../../actions/deltas";

const {SET_RELOADING_ENROLMENTS_AND_COHORTS_STATE} = deltas.actionTypes;

export default createStateReducer(reloadingEnrolmentsAndCohortsStates, null, SET_RELOADING_ENROLMENTS_AND_COHORTS_STATE);

export const selectIsReloadingEnrolmentsAndCohorts = (state) => reloadingEnrolmentsAndCohortsStates.LOADING === state.states.reloadingEnrolmentsAndCohorts.state;
